import React, { FC, useState } from "react";
import { Document } from "../../PreAuth/PreAuthIhx/PreAuthIhx";
import { Form, Input, Select, Spin } from "antd";
import { Button } from "antd";
import { useUserFunctionalities } from "../../../../utils/UserFunctionalities";
import DischargeDocuments from "./CghsTabs/DischargeDocuments";
import DischargeDetails from "./CghsTabs/DischargeDetails";
import TreatingDoctorDetails from "./CghsTabs/TreatingDoctorDetails";
import CovidCaseDetails from "./CghsTabs/CovidCaseDetails";
import TreatmentSurgeryDate from "./CghsTabs/TreatmentSurgeryDate";
import Discharge from "./CghsTabs/Discharge";
import ResponseDischargeDocuments from "./CghsTabs/ResponseDischargeDocuments";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { ROUTES } from "../../../../utils/constants";
import { openBillAuditForMapping } from "../../../../utils/billAuditUrlUtils";
import { Link, useNavigate } from "react-router-dom";
import CghsProcedureClaim from "../../Claim/CGHS/CghsProcedureClaim";
import { Col } from "antd";
import { Row } from "antd";
import DischargeFields from "./CghsNewTabs/DischargeFields";
import { DownloadOutlined } from "@ant-design/icons";

type DischargeCghsNewProps = {
  documentTypes: Document[];
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks: string | null;
  }[];
  handleFileChange: any;
  handleOpen: any;
  form: any;
  handleSubmit: any;
  handleIntimate: any;
  handleSubmitOnPortal: any;
  handleApprove: any;
  isApproved: boolean;
  isApprovedInitiated: boolean;
  documentRequestResponseDocuments: any;
  loading: boolean;
  handleSaveData: any;
  activeKey: any;
  currentVisitStage: any;
  isSubmitting: boolean;
  isSubmittingManually: boolean;
  isIntimating: boolean;
  isSaving: boolean;
  currentActiveStage: any;
  handleSaveConfirmationModal: any;
  portalSubmission: boolean;
  caseDischargeId: any;
  caseDischargeData: any;
  doctorTypeNameList: any;
  uploadFileList: any;
  cghsProcedures: any;
  handleSaveBillAmount: any;
  isSavingTotalBillAmount: boolean;
  handleDownloadAbhinandanPatra: any;
  isDownloadingPatra: boolean;
};

const dischargeTypes = [
  { label: "Normal Discharge", value: "Normal Discharge" },
  // { label: "LAMA", value: "LAMA" },
  // { label: "DAMA", value: "DAMA" },
  { label: "Death", value: "Death" },
];

const DischargeCghsNew: FC<DischargeCghsNewProps> = ({
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  form,
  handleSubmit,
  handleIntimate,
  handleSubmitOnPortal,
  handleApprove,
  isApproved,
  isApprovedInitiated,
  documentRequestResponseDocuments,
  loading,
  handleSaveData,
  currentVisitStage,
  activeKey,
  currentActiveStage,
  portalSubmission,
  caseDischargeId,
  caseDischargeData,
  isSubmitting,
  isSubmittingManually,
  isIntimating,
  isSaving,
  handleSaveConfirmationModal,
  doctorTypeNameList,
  uploadFileList,
  cghsProcedures,
  handleSaveBillAmount,
  isSavingTotalBillAmount,
  handleDownloadAbhinandanPatra,
  isDownloadingPatra
}) => {
  const { hasFunctionality } = useUserFunctionalities();
  const navigate = useNavigate();
  const { auth, patients } = useSelector((state: RootState) => state);
  const isMedicinesProvided = Form.useWatch("medicinesProvided", form);
  //   const [type, setType] = useState<any>(null);

  const type = Form.useWatch("typeOfDischarge", form);

  const totalBillAmount = Form.useWatch("totalBillAmount", form);
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          width: "100%",
          gap: "16px",
        }}
      >
        <Form form={form} style={{ width: "100%" }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
              <Form.Item
                label="Hospital Bill Amount"
                name="totalBillAmount"
                style={{ color: "#575757" }}
                rules={[
                  {
                    required: true,
                    message: "Please select amount",
                  },
                  {
                    pattern: /^(\d+(\.\d{1,2})?|\.\d{1,2})$/,
                    message:
                      "Only numeric values with up to 2 decimal places are allowed!",
                  },
                  // {
                  //   pattern: /^(\d+(\.\d+)?|\.\d+)$/,
                  //   message: "Only Numeric values are allowed!",
                  // },
                ]}
              >
                <Input
                  placeholder="Please input amount"
                  style={{ color: "black" }}
                  disabled={
                    (caseDischargeId && caseDischargeData?.totalBillAmount) ||
                    portalSubmission
                  }
                />
              </Form.Item>
            </Col>

            {/* {caseDischargeId && caseDischargeData?.totalBillAmount ? (
            <></>
          ) : (
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Button
                type="primary"
                style={{
                  backgroundColor: "rgb(0, 76, 143)",
                  color: "#fff",
                  boxShadow: "0px 2px 8px 0px #00000040",
                  width: "100%",
                }}
                onClick={handleSaveBillAmount}
                loading={isSavingTotalBillAmount}
              >
                SAVE BILL AMOUNT
              </Button>
            </Col>
          )} */}
          </Row>

          <Form.Item
            label="Discharge Type"
            name="typeOfDischarge"
            rules={[
              {
                required: true,
                message: "Select Discharge Stage",
              },
            ]}
          >
            <Select
              options={dischargeTypes}
              placeholder="Select Discharge Type"
              // onChange={setType}
              style={{ width: 300 }}
            />
          </Form.Item>

          {type && <DischargeFields type={type} form={form} />}
        </Form>

        <Button
          type="primary"
          icon={<DownloadOutlined />}
          style={{
            background: "rgb(0, 84, 157)",
            width: "200px",
            fontSize: "0.84rem",
            alignSelf: "flex-start",
          }}
          loading={isDownloadingPatra}
          onClick={handleDownloadAbhinandanPatra}
        >
          Abhinandan Patra Form
        </Button>
      </div>
      {/* <CghsProcedureClaim cghsProcedures={cghsProcedures} /> */}
      {/* <DischargeDetails
        form={form}
        portalSubmission={portalSubmission}
        isApproved={isApproved}
      />
      {auth?.role?.role !== "FO_STAFF" ? (
        <CovidCaseDetails
          form={form}
          portalSubmission={portalSubmission}
          isApproved={isApproved}
        />
      ) : (
        <></>
      )}
      {auth?.role?.role !== "FO_STAFF" ? (
        <TreatingDoctorDetails
          form={form}
          doctorTypeNameList={doctorTypeNameList}
          portalSubmission={portalSubmission}
          isApproved={isApproved}
        />
      ) : (
        <></>
      )}
      {auth?.role?.role !== "FO_STAFF" ? (
          <Discharge
          form={form}
          portalSubmission={portalSubmission}
          isApproved={isApproved}
          />
        ) : (
            <></>
        )} */}

      {/* <TreatmentSurgeryDate form={form} /> */}
      {loading ? (
        <div
          style={{
            margin: "auto",
            width: "100%,",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        documentRequestResponseDocuments?.["requestedDocuments"]?.length >
          0 && (
          <DischargeDocuments
            documentTypes={documentTypes}
            documentUrls={documentUrls}
            handleFileChange={handleFileChange}
            handleOpen={handleOpen}
            documentRequestResponseDocuments={documentRequestResponseDocuments}
            portalSubmission={portalSubmission}
            isApproved={isApproved}
            uploadFileList={uploadFileList}
            isIntimated={caseDischargeData?.intimated}
            isMedicinesProvided={isMedicinesProvided}
            type={type}
            // form={form}
          />
        )
      )}

      {documentRequestResponseDocuments?.["responseDocuments"]?.length > 0 && (
        <ResponseDischargeDocuments
          documentTypes={documentTypes}
          documentUrls={documentUrls}
          handleFileChange={handleFileChange}
          handleOpen={handleOpen}
          documentRequestResponseDocuments={documentRequestResponseDocuments}
          handleSaveData={handleSaveData}
          currentStage={currentVisitStage}
          activeKey={activeKey}
          portalSubmission={portalSubmission}
          uploadFileList={uploadFileList}
        />
      )}

      <div className="buttons" style={{ margin: "16px 0" }}>
        {
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.8rem",
            }}
          >
            {caseDischargeData?.submitted || caseDischargeData?.initiated ? (
              // || caseDischargeData?.approved
              <></>
            ) : !caseDischargeId ? (
              <div style={{ width: "16%" }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                  }}
                  // onClick={handleSubmit}
                  onClick={() => handleSaveConfirmationModal("save")}
                  // loading={isSaving}
                >
                  SAVE
                </Button>
              </div>
            ) : (
              // !(
              //   auth?.role?.role == "FO_STAFF" && caseDischargeData?.intimated
              // ) &&
              <div style={{ width: "16%" }}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "rgb(0, 76, 143)",
                    color: "#fff",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    width: "100%",
                  }}
                  // onClick={handleSubmit}
                  onClick={() => handleSaveConfirmationModal("update")}
                  loading={isSaving}
                >
                  Update
                </Button>
              </div>
            )}
            {hasFunctionality("dischargeIntimation") ? (
              caseDischargeData?.intimated ||
              caseDischargeData?.submitted ||
              caseDischargeData?.initiated ||
              caseDischargeData?.approved ? (
                <></>
              ) : (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleIntimate}
                    onClick={() => handleSaveConfirmationModal("intimate")}
                    loading={isIntimating}
                  >
                    Send To QC
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}

            {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "OP" &&
              (hasFunctionality("opdBillList") ||
                hasFunctionality("ipdBillList")) && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    onClick={() =>
                      openBillAuditForMapping(
                        patients?.fetchBasicDetails?.visitInfoResponse
                          ?.billMappingId,
                        patients?.fetchBasicDetails?.casesResponse?.healthCareId,
                        patients?.fetchBasicDetails?.casesResponse?.schemeType,
                      )
                    }
                  >
                    Bill Audit
                  </Button>
                </div>
              )}
            {/* {(patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "IP" ||
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                "EMERGENCY") &&
              hasFunctionality("ipdBillList") && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      // opacity: !isApproved ? 1 : 0.5,
                      // pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
                        navigate({
                          pathname: `${ROUTES.PATIENT_BILLING_LIST}/${patients?.fetchBasicDetails?.casesResponse?.id}/${patients?.fetchBasicDetails?.visitInfoResponse?.id}`,
                        });
                      }
                    }}
                  >
                    Bill Audit
                  </Button>
                </div>
              )} */}

            {hasFunctionality("dischargeApprover") &&
              !caseDischargeData?.initiated &&
              !caseDischargeData?.approved &&
              !caseDischargeData?.submitted && (
                <div style={{ width: "16%" }}>
                  <Button
                    loading={isApprovedInitiated}
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleApprove}
                    onClick={() => handleSaveConfirmationModal("approve")}
                    disabled={isApproved}
                  >
                    QC Approve
                  </Button>
                </div>
              )}

            {hasFunctionality("dischargeSubmission") ? (
              caseDischargeData?.submitted || caseDischargeData?.initiated ? (
                <></>
              ) : (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmitOnPortal}
                    onClick={() => handleSaveConfirmationModal("submit")}
                    loading={isSubmitting}
                  >
                    {patients?.fetchBasicDetails?.casesResponse
                      ?.integratedWithPortal
                      ? "Initiate"
                      : "Submit Manually"}
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}

            {hasFunctionality("dischargeSubmission") ? (
              caseDischargeData?.submitted || caseDischargeData?.initiated ? (
                <></>
              ) : (
                patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase()?.includes("CAPF") &&
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmitOnPortal}
                    onClick={() => handleSaveConfirmationModal("submitManually")}
                    loading={isSubmittingManually}
                  >
                    {"Submit Manually"}
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}
          </div>
        }
      </div>
    </div>
  );
};

export default DischargeCghsNew;
